// Token相关工具函数

export function getToken() {
  return localStorage.getItem('admin_token')
}

export function setToken(token) {
  localStorage.setItem('admin_token', token)
}

export function removeToken() {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_user')
}

export function getUser() {
  const userStr = localStorage.getItem('admin_user')
  if (userStr) {
    try {
      return JSON.parse(userStr)
    } catch (e) {
      return null
    }
  }
  return null
}

export function setUser(user) {
  localStorage.setItem('admin_user', JSON.stringify(user))
}

